import { EpisodeInputValue, YoutubeVideoInputValue } from './types';

export const getYoutubeVideoTitle = ({
  title,
  url,
}: YoutubeVideoInputValue): string => title || url;

export const getEpisodeTitle = (episode: EpisodeInputValue): string => {
  if (episode.type === 'youtubeVideo') {
    return getYoutubeVideoTitle(episode);
  }

  const { podcast, title } = episode;

  return title ? `${podcast.title} (${title})` : podcast.title;
};
